<template>
  <div class="select_list">
    <template v-if="!selected">
      <p v-for="item in list" :key="item.value" class="filter_select">
        <label>
          <input
            type="checkbox"
            :value="item.value"
            :checked="isChecked(item.value)"
            @click="(e) => handleClick(item.value, e)"
            @change="handleChange(item.value)"
          />
          {{ item.label }}<i v-if="item.pending" class="icon_pending"></i>
        </label>
      </p>
    </template>
    <template v-else>
      <p v-for="item in list" :key="item.value">
        {{ item.label }}
        <Base.Button size="xs" icon="delete" txt="none" @click="handleDelete(item.value)"
          >삭제</Base.Button
        >
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { Base } from "../BaseFactory";

const props = defineProps({
  checked: Boolean,
  modelValue: { type: [String, Array], default: "" },
  list: { type: Array<{ label: string; value: string }>, default: () => [] },
  selected: {
    type: Boolean,
    default: false,
  },
  pending: {
    type: Boolean,
    default: false,
  },
  maxCount: { type: Number, default: null },
});

const emit = defineEmits(["update:modelValue", "delete"]);

const isChecked = (value: string) => {
  if (Array.isArray(props.modelValue)) {
    return props.modelValue.includes(value);
  }
  return props.modelValue === value;
};

const handleClick = (value: string, event: MouseEvent) => {
  // maxCount 검증
  if (props.maxCount && Array.isArray(props.modelValue)) {
    const willBeChecked = !props.modelValue.includes(value);
    if (willBeChecked && props.modelValue.length >= props.maxCount) {
      event.preventDefault(); // 체크 방지
      return;
    }
  }
  // 정상적인 경우 change 이벤트 발생
};

const handleChange = (value: string) => {
  if (Array.isArray(props.modelValue)) {
    // 다중 선택
    const newValue = props.modelValue.includes(value)
      ? props.modelValue.filter((v) => v !== value)
      : [...props.modelValue, value];
    emit("update:modelValue", newValue);
  } else {
    // 단일 선택
    emit("update:modelValue", value);
  }
};

const handleDelete = (value: string) => {
  if (Array.isArray(props.modelValue)) {
    emit(
      "update:modelValue",
      props.modelValue.filter((v) => v !== value)
    );
  } else {
    emit("update:modelValue", "");
  }
  emit("delete", value);
};
</script>
